export default __webpack_public_path__ + "static/media/messageBlue.e98e0ff8.svg";